var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWrapper = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M.481 0h14v14h-14z"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.247 4.469a1.633 1.633 0 1 0-3.266 0 1.633 1.633 0 0 0 3.266 0M7.614 1.836a2.633 2.633 0 1 1 0 5.266 2.633 2.633 0 0 1 0-5.266M4.77 9.215a8.46 8.46 0 0 1 5.688 0 .59.59 0 0 1 .389.551v.702a.54.54 0 0 1-.617.535l-.209-.03a17 17 0 0 0-4.813 0l-.21.03a.54.54 0 0 1-.616-.535v-.702c0-.247.155-.468.388-.551m6.025-.942a9.46 9.46 0 0 0-6.361 0 1.59 1.59 0 0 0-1.052 1.493v.702c0 .937.83 1.657 1.758 1.525l.21-.03a16 16 0 0 1 4.53 0l.209.03a1.54 1.54 0 0 0 1.758-1.525v-.702c0-.67-.421-1.267-1.052-1.493m.02-4.464a1.176 1.176 0 1 1 0 2.352.5.5 0 0 0 0 1 2.176 2.176 0 1 0 0-4.352.5.5 0 0 0 0 1m1.428 3.762a.5.5 0 1 0-.19.981q.488.094.96.263c.141.05.235.183.235.332v.551a.318.318 0 0 1-.362.315l-.165-.024a.5.5 0 1 0-.141.99l.164.024a1.317 1.317 0 0 0 1.504-1.305v-.55c0-.573-.36-1.083-.898-1.275a7.5 7.5 0 0 0-1.107-.303M4.148 3.809a1.176 1.176 0 1 0 0 2.352.5.5 0 0 1 0 1 2.176 2.176 0 1 1 0-4.352.5.5 0 0 1 0 1M2.721 7.571a.5.5 0 0 1 .19.981q-.488.094-.961.263a.35.35 0 0 0-.234.332v.551c0 .194.17.342.362.315l.164-.024a.5.5 0 1 1 .142.99l-.164.024A1.317 1.317 0 0 1 .716 9.698v-.55c0-.573.36-1.083.898-1.275q.544-.194 1.107-.303",
  clipRule: "evenodd"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.481 0h14v14h-14z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.481 0h14v14h-14z"
})))));
export { SvgWrapper as ReactComponent };
export default __webpack_public_path__ + "static/media/wrapper.8c73bd493c0f74abb13b33a4a2088174.svg";